import { api } from "@/plugins/api";

const state = {
  messages: [],
};

const getters = {
  getAllMessages: (state) => state.messages,

  getMessageById: (state) => (id) =>
    state.messages.filter((message) => message.id === id),
};

const actions = {
  async fetchAllMessages({ commit }) {
    try {
      const response = await api.get("/messages");
      const messages = response.data.data;
      //console.log("actions", actions);
      commit("setMessages", messages);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async readMessage(id) {
    try {
      const response = await api.post(`/messages/${id}/read`);
      console.log("response", response.data.data);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addMessage({ commit }, data) {
    try {
      const response = await api.post(`/messages`, {
        text: data.text,
        recipients: data.users,
      });
      console.log("response", response.data.data);
      commit("addMessage", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async send4Cut() {
    try {
      await api.post(`/messages/cut/all`);
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setMessages(state, messages) {
    state.messages = messages;
  },
  addMessage(state, message) {
    console.log("message:", message);
    state.messages.unshift(message);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
